<template>
  <div class="pay-container">
    <van-nav-bar :title="$route.meta.title">
      <template #left>
        <van-icon @click="back" name="arrow-left" color="#46474B" size="20px" />
      </template>
    </van-nav-bar>
    <div class="pay-loading text-align-center">
      <img src="@/assets/pay-state/pay-loading.png" alt="">
      <p>支付查询中({{ second }}s)...</p>
    </div>
  </div>
</template>

<script>
import { queryOrderStatus } from '@/api/falinapi'
import { callApp } from '@/libs/bridge'
import { NavBar, Icon } from 'vant'
export default {
  components: {
    'van-icon': Icon,
    'van-nav-bar': NavBar
  },
  data () {
    return {
      second: 8,
      timer: ''
    }
  },
  mounted () {
    this.forIosHuiPay()
  },
  methods: {
    /** 判断是否是在法临环境下 */
    forIosHuiPay () {
      console.log('webkit:', window.webkit)
      console.log('ImLawApp:', window.ImLawApp)
      if (!window.webkit && !window.ImLawApp) {
        this.$router.push({
          path: '/confirm-order/pay-ios-bridge'
        })
      } else {
        window.physicsBackFn = this.back
        /* 延迟5s后查询订单状态 */
        this.timer = setInterval(() => {
          this.second--
          if (this.second === 0) {
            clearInterval(this.timer)
            /* 查询订单状态 */
            this.queryFun()
          } else {
            this.queryFunSecond()
          }
        }, 1000)
      }
    },
    queryFun () {
      queryOrderStatus({ orderId: this.$route.query.orderId }).then(({ data }) => {
        const { orderId } = this.$route.query
        const { serviceCode, lawyerId, lawyerName, buyServiceType, businessId, createFrom, payType, synHistoryId, synWdId,articleId } = data
        if (data.status === 1001) {
          this.$router.push({
            path: `/confirm-order/pay-success?buyServiceType=${buyServiceType}&lawyerName=${lawyerName}&lawyerId=${lawyerId}&businessId=${businessId}&serviceCode=${serviceCode}&createFrom=${createFrom}&articleId=${articleId}`
          })
          return false
        }
        this.$router.push({
          path: `/confirm-order/pay-error?orderId=${orderId}&serviceCode=${serviceCode}&lawyerId=${lawyerId}&buyServiceType=${buyServiceType}&businessId=${businessId}&payType=${payType}&synHistoryId=${synHistoryId}&synWdId=${synWdId}`
        })
      })
    },
    queryFunSecond () {
      queryOrderStatus({ orderId: this.$route.query.orderId }).then(({ data }) => {
        const { serviceCode, lawyerId, lawyerName, buyServiceType, businessId, createFrom, articleId } = data
        if (data.status === 1001) {
          clearInterval(this.timer)
          this.$router.push({
            path: `/confirm-order/pay-success?buyServiceType=${buyServiceType}&lawyerName=${lawyerName}&lawyerId=${lawyerId}&businessId=${businessId}&serviceCode=${serviceCode}&createFrom=${createFrom}&articleId=${articleId}`
          })
          return false
        }
      })
    },
    back () {
      callApp('finishActivity')
    }
  },
  destroyed () {
    clearInterval(this.timer)
  }
}
</script>

<style scoped lang="scss">

.pay-container{
  min-height: 100vh;
  background: white;
}
.pay-loading{
  font-size: 0;
  img{
    padding-top: 48px;
    width: 121px;
    height: 120px;
  }
  p{
    padding: 29px 0 48px;
    font-size: 18px;
    color: #333333;
  }
}
</style>
